import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-coupon-form',
  templateUrl: './coupon-form.component.html',
  styleUrls: ['./coupon-form.component.css']
})
export class CouponFormComponent implements OnInit {
  form: FormGroup;
  datesError = false;
  @Input() coupon: any;
  @Output() couponSaved: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      emissionDateStart: [this.coupon.emission_date_start],
      emissionDateEnd: [this.coupon.emission_date_end],
      fruitionDateStart: [this.coupon.fruition_date_start],
      fruitionDateEnd: [this.coupon.fruition_date_end],
    });
  }

  save() {
    if (
      this.form.get('emissionDateStart').value > this.form.get('fruitionDateEnd').value ||
      this.form.get('emissionDateEnd').value > this.form.get('fruitionDateEnd').value
    ) {
      this.datesError = true;
      return;
    }
    const newCouponData = {
      ...this.coupon,
      emission_date_start: this.form.get('emissionDateStart').value ? moment(this.form.get('emissionDateStart').value).format('YYYY-MM-DD') : null,
      emission_date_end: this.form.get('emissionDateEnd').value ? moment(this.form.get('emissionDateEnd').value).format('YYYY-MM-DD') : null,
      fruition_date_start: this.form.get('fruitionDateStart').value ? moment(this.form.get('fruitionDateStart').value).format('YYYY-MM-DD') : null,
      fruition_date_end: this.form.get('fruitionDateEnd').value ? moment(this.form.get('fruitionDateEnd').value).format('YYYY-MM-DD') : null
    }
    this.couponSaved.emit(newCouponData);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-list/coupon-form/coupon-form.component.ts